// extracted by mini-css-extract-plugin
export default {"text":"styles_text__jmohg","moreInfo":"styles_moreInfo__I1L8C","bold":"styles_bold__ufA+j"};